import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Navbar from './components/Navbar';
import MobileNavbar from './components/mobile/MobileNavbar';
import Home from './pages/Home';
import MobileHome from './pages/mobile/MobileHome';
import About from './pages/About';
import Contact from './pages/Contact';
import Episodes from './pages/Episodes';
import NotFound from './pages/NotFound';
import ScrollToTop from './components/ScrollToTop';
import SocialBar from './components/SocialBar';
import PageTransition from './components/PageTransition';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/admin/ProtectedRoute';

// Admin pages
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import Unauthorized from './pages/admin/Unauthorized';

function App() {
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  useEffect(() => {
    // Only log 404 errors for non-admin routes
    if (location.pathname !== '/' && 
        location.pathname !== '/episodes' && 
        location.pathname !== '/about' && 
        location.pathname !== '/contact' && 
        !location.pathname.startsWith('/admin')) {
      console.error(`GET ${window.location.href} 404 (Not Found)`);
      document.title = '404 Not Found - Basketball Culture Podcast';
    }
  }, [location]);

  return (
    <AuthProvider>
      <HelmetProvider>
        <div className="App">
          <ScrollToTop />
          <SocialBar />
          {isMobile ? <MobileNavbar /> : <Navbar />}
          <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
              {/* Admin Routes */}
              <Route path="/admin/login" element={<Login />} />
              <Route path="/admin/unauthorized" element={<Unauthorized />} />
              <Route 
                path="/admin/dashboard" 
                element={
                  <ProtectedRoute requireAdmin={true}>
                    <Dashboard />
                  </ProtectedRoute>
                } 
              />
              
              {/* Main Routes */}
              <Route path="/" element={
                <PageTransition>
                  {isMobile ? <MobileHome /> : <Home />}
                </PageTransition>
              } />
              <Route path="/episodes" element={
                <PageTransition>
                  <Episodes />
                </PageTransition>
              } />
              <Route path="/about" element={
                <PageTransition>
                  <About />
                </PageTransition>
              } />
              <Route path="/contact" element={
                <PageTransition>
                  <Contact />
                </PageTransition>
              } />
              <Route path="*" element={
                <PageTransition>
                  <NotFound />
                </PageTransition>
              } />
            </Routes>
          </AnimatePresence>
        </div>
      </HelmetProvider>
    </AuthProvider>
  );
}

export default App;